import AlwaysOnSurveys from './AlwaysOnSurveys';

export type { AlwaysOnSurveysProps } from './AlwaysOnSurveys.types';

export default AlwaysOnSurveys;
